module.exports = __webpack_public_path__ + "4afb46f40.png";